<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group label-for="input-coreDomain">
      <template v-slot:label>{{ $t("coreDomain") }}</template>
      <b-form-input
        id="input-coreDomain"
        v-model="localCoreDomain"
        minlength="2"
        maxlength="50"
        required
      />
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Prop} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as meetingService from "@/service/meetingService";

  @Component
  export default class EditContactModal extends BaseComponent {
    @Prop({ required: true }) meetingId!: number;
    @Prop({ required: true }) coreDomain!: number;

    formErrorMsg = "";
    isSubmitting = false;
    localCoreDomain = "";
    readonly coreDomainPattern = /^[0-9]+$/;

    created() {
      this.localCoreDomain = String(this.coreDomain);
    }

    onClickCancel() {
        this.$bvModal.hide('domain-select-modal');
    }

    async submitForm() {
      this.formErrorMsg = "";

      if (!this.coreDomainPattern.test(this.localCoreDomain)) {
        this.formErrorMsg = this.$t("enterInfrastructureID").toString();
        return;
      }

      this.isSubmitting = true;
      try {
        await meetingService.updateApiConfig(
          Number(this.meetingId),
          Number(this.localCoreDomain)
        );
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$emit("domainSelected"); //load lại fetchMeeting
        this.$bvModal.hide('domain-select-modal');
      } 
      catch (e) {
        this.toastErrorOldType(e);  
      } finally {
        this.isSubmitting = false;
      }
    }
  }
</script>
